// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2_dX5","dragIcon":"Choice_dragIcon__2VfRf","left":"Choice_left__hkF4K","input":"Choice_input__1TIjf"};